/// <amd-module name="TFS/Admin/Common/RestClient/OrganizationPolicy" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\organizationpolicy.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as OrganizationPolicy from "../Contracts/OrganizationPolicy";
import * as VS_Services from "VSS/Platform/Contracts/WebApi";

export interface IOrganizationPolicyRestClient extends IVssRestClient {
    /**
     * @param policyName - 
     * @param defaultValue - 
     */
    getPolicy(policyName: string, defaultValue: string): Promise<OrganizationPolicy.Policy>;
    /**
     * @param patchDocument - 
     * @param policyName - 
     */
    updatePolicy(patchDocument: VS_Services.JsonPatchDocument, policyName: string): Promise<void>;
    /**
     * @param policyNames - 
     * @param defaultValues - 
     */
    getPolicies(policyNames: string[], defaultValues: string[]): Promise<{ [key: string] : OrganizationPolicy.Policy; }>;
    /**
     * @param policyName - 
     */
    getPolicyInformation(policyName: string): Promise<OrganizationPolicy.PolicyInfo>;
    /**
     * @param policyNames - 
     */
    getPolicyInformations(policyNames?: string[]): Promise<{ [key: string] : OrganizationPolicy.PolicyInfo; }>;
}

class OrganizationPolicyRestClient extends RestClientBase implements IOrganizationPolicyRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param policyName - 
     * @param defaultValue - 
     */
    public async getPolicy(
        policyName: string,
        defaultValue: string
        ): Promise<OrganizationPolicy.Policy> {

        const queryValues: any = {
            defaultValue: defaultValue
        };

        return this.beginRequest<OrganizationPolicy.Policy>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/OrganizationPolicy/Policies/{policyName}",
            routeValues: {
                policyName: policyName
            },
            queryParams: queryValues
        });
    }

    /**
     * @param patchDocument - 
     * @param policyName - 
     */
    public async updatePolicy(
        patchDocument: VS_Services.JsonPatchDocument,
        policyName: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/OrganizationPolicy/Policies/{policyName}",
            routeValues: {
                policyName: policyName
            },
            customHeaders: {
                "Content-Type": "application/json-patch+json",
            },
            body: patchDocument
        });
    }

    /**
     * @param policyNames - 
     * @param defaultValues - 
     */
    public async getPolicies(
        policyNames: string[],
        defaultValues: string[]
        ): Promise<{ [key: string] : OrganizationPolicy.Policy; }> {

        const queryValues: any = {
            policyNames: policyNames && policyNames.join(","),
            defaultValues: defaultValues && defaultValues.join(",")
        };

        return this.beginRequest<{ [key: string] : OrganizationPolicy.Policy; }>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/OrganizationPolicy/PoliciesBatch",
            queryParams: queryValues
        });
    }

    /**
     * @param policyName - 
     */
    public async getPolicyInformation(
        policyName: string
        ): Promise<OrganizationPolicy.PolicyInfo> {

        return this.beginRequest<OrganizationPolicy.PolicyInfo>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/OrganizationPolicy/PolicyInformation/{policyName}",
            routeValues: {
                policyName: policyName
            }
        });
    }

    /**
     * @param policyNames - 
     */
    public async getPolicyInformations(
        policyNames?: string[]
        ): Promise<{ [key: string] : OrganizationPolicy.PolicyInfo; }> {

        const queryValues: any = {
            policyNames: policyNames && policyNames.join(",")
        };

        return this.beginRequest<{ [key: string] : OrganizationPolicy.PolicyInfo; }>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/OrganizationPolicy/PolicyInformation/{policyName}",
            queryParams: queryValues
        });
    }

}

export const OrganizationPolicyClientName = "OrganizationPolicy-Admin.IOrganizationPolicyRestClient";

export function getOrganizationPolicyClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IOrganizationPolicyRestClient {
    return pageContext.getRestClient<IOrganizationPolicyRestClient>(OrganizationPolicyClientName, options);
}

RestClients.add(OrganizationPolicyClientName, { 
    factory: OrganizationPolicyRestClient
});
